var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"cus_image_upload",attrs:{"action":_vm.fileUploadUrl,"show-file-list":false,"before-upload":_vm.beforeupload,"http-request":_vm.customupload,"on-success":_vm.onsuccess}},[(_vm.imageUrl)?[_c('img',{attrs:{"src":_vm.imageUrl}})]:[_c('i',{staticClass:"el-icon-plus"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }